<template>
	<div class="col-md-12">
        <div class="form-row">
            <div class="col-md-3 mb-2">
                <label for="giroNegocio">Giro de negocio:</label>
                <catalogo-segmentos id="giroNegocio" name="giroNegocio" v-model="form.giroNegocio"></catalogo-segmentos>
                <div v-if="errorsFields && errorsFields.giroNegocio" class="text-danger">
                    <small>
                        {{ errorsFields.giroNegocio[0] }}
                    </small>
                </div>
            </div>
            
            <div class="col-md-3 mb-2 valign-wrapper">
                <div class="d-block w-100">
                    <label
                        class="label-sm" 
                        for="numeroSites">¿Tiene varios sites?</label>
                    <input type="numeric" id="numeroSites" class="form-control form-control-sm" name="numeroSites" v-model="form.numeroSites" placeholder="Indicar cuántos">
                    <div v-if="errorsFields && errorsFields.numeroSites" class="text-danger">
                        <small>
                            {{ errorsFields.numeroSites[0] }}
                        </small>
                  </div>
                </div>
            </div>

            <div class="col-md-3 mb-2">
                <label for="numeroEmpleados">
                    ¿Cuántos empleados tienen?
                </label>
                <input type="number" id="numeroEmpleados" name="numeroEmpleados" v-model="form.numeroEmpleados" class="form-control form-control-sm">
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12 mb-2 valign-wrapper">
                <div class="custom-control custom-checkbox">
                    <input 
                        type="checkbox" 
                        class="custom-control-input" 
                        id="tieneTeletrabajo" 
                        name="tieneTeletrabajo" v-model="form.tieneTeletrabajo">
                    <label
                        class="custom-control-label label-sm" 
                        for="tieneTeletrabajo">¿Tiene teletrabajo?</label>
                </div>
                <div v-if="errorsFields && errorsFields.tieneTeletrabajo" class="text-danger">
                    <small>
                        {{ errorsFields.tieneTeletrabajo[0] }}
                    </small>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-6 mb-2 valign-wrapper">
                <div class="form-row w-100">
                    <div class="col-md-6 mb-2">
                        <div class="custom-control custom-checkbox">
                            <input 
                                type="checkbox" 
                                class="custom-control-input" 
                                id="tieneSeguroMedico" 
                                name="tieneSeguroMedico" v-model="form.tieneSeguroMedico">
                            <label 
                                class="custom-control-label label-sm" 
                                for="tieneSeguroMedico">¿Tiene seguro médico?</label>
                        </div>
                        <div v-if="errorsFields && errorsFields.tieneSeguroMedico" class="text-danger">
                            <small>
                                {{ errorsFields.tieneSeguroMedico[0] }}
                            </small>
                        </div>
                        <catalogo-aseguradoras name="aseguradora" v-model="form.aseguradora" v-if="form.tieneSeguroMedico"></catalogo-aseguradoras>
                        <div v-if="errorsFields && errorsFields.aseguradora" class="text-danger">
                            <small>
                                {{ errorsFields.aseguradora[0] }}
                            </small>
                        </div>
                    </div>

                    <div class="col-md-6 mb-2">
                        <div class="custom-control custom-checkbox">
                            <input 
                                type="checkbox" 
                                class="custom-control-input" 
                                id="tieneCorredorSeguros" 
                                name="tieneCorredorSeguros" v-model="form.tieneCorredorSeguros">
                            <label 
                                class="custom-control-label label-sm" 
                                for="tieneCorredorSeguros">¿Tiene corredor de seguros?</label>
                        </div>
                        <div v-if="errorsFields && errorsFields.tieneCorredorSeguros" class="text-danger">
                            <small>
                                {{ errorsFields.tieneCorredorSeguros[0] }}
                            </small>
                        </div>

                        <catalogo-intermediarios name="intermediario" v-model="form.intermediario" v-if="form.tieneCorredorSeguros"></catalogo-intermediarios>
                        <div v-if="errorsFields && errorsFields.intermediario" class="text-danger">
                            <small>
                                {{ errorsFields.intermediario[0] }}
                            </small>
                        </div>
                    </div>  
                </div>
            </div>

            <div class="col-md-2 mb-2">
                <label for="renovacionPoliza">¿Cuándo renuevan póliza?</label>
                <date-picker id="renovacionPoliza" name="renovacionPoliza" v-model="form.renovacionPoliza" class="form-control-sm"></date-picker>
                <div v-if="errorsFields && errorsFields.renovacionPoliza" class="text-danger">
                    <small>
                        {{ errorsFields.renovacionPoliza[0] }}
                    </small>
                </div>
            </div>

            <div class="col-md-4 mb-2">
                <div class="custom-control custom-checkbox">
                    <input 
                        type="checkbox" 
                        class="custom-control-input" 
                        id="tieneSeguroVida" 
                        name="tieneSeguroVida" v-model="form.tieneSeguroVida">
                    <label 
                        class="custom-control-label label-sm" 
                        for="tieneSeguroVida">¿Tienen seguro de vida?</label>
                </div>
                <div v-if="errorsFields && errorsFields.tieneSeguroVida" class="text-danger">
                    <small>
                        {{ errorsFields.tieneSeguroVida[0] }}
                    </small>
                </div>

                <catalogo-aseguradoras name="aseguradoraVida" v-model="form.aseguradoraVida" v-if="form.tieneSeguroVida"></catalogo-aseguradoras>
                <div v-if="errorsFields && errorsFields.aseguradoraVida" class="text-danger">
                    <small>
                        {{ errorsFields.aseguradoraVida[0] }}
                    </small>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-4 mb-2">
                <div class="form-row">
                    <div class="col-md-12 mb-2">
                        <label class="label-sm">¿Aplica para qué niveles?</label>
                        <div class="form-row">
                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="polizaAplicaGerentes" 
                                        name="polizaAplicaGerentes" v-model="form.polizaAplicaGerentes">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="polizaAplicaGerentes">Gerentes</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.polizaAplicaGerentes" class="text-danger">
                                    <small>
                                        {{ errorsFields.polizaAplicaGerentes[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="polizaAplicaMandosMedios" 
                                        name="polizaAplicaMandosMedios" v-model="form.polizaAplicaMandosMedios">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="polizaAplicaMandosMedios">Mandos medios</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.polizaAplicaMandosMedios" class="text-danger">
                                    <small>
                                        {{ errorsFields.polizaAplicaMandosMedios[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="polizaAplicaEmpresa" 
                                        name="polizaAplicaEmpresa" v-model="form.polizaAplicaEmpresa">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="polizaAplicaEmpresa">Toda la empresa</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.polizaAplicaEmpresa" class="text-danger">
                                    <small>
                                        {{ errorsFields.polizaAplicaEmpresa[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="polizaNoAplica" 
                                        name="polizaNoAplica" v-model="form.polizaNoAplica">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="polizaNoAplica">No aplica</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.polizaNoAplica" class="text-danger">
                                    <small>
                                        {{ errorsFields.polizaNoAplica[0] }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 border-top border-bottom valign-wrapper">
                        <div class="form-row">
                            <div class="col-md-8 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="incluyeChequeoMedio"
                                    name="incluyeChequeoMedio" v-model="form.incluyeChequeoMedio">
                                    <label
                                        class="custom-control-label label-sm"
                                    for="incluyeChequeoMedio">¿La póliza incluye chequeo médico?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.incluyeChequeoMedio" class="text-danger">
                                    <small>
                                        {{ errorsFields.incluyeChequeoMedio[0] }}
                                    </small>
                                </div>
                            </div>
                            <div class="col-md-4 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="incluyeOftanmolico"
                                    name="incluyeOftanmolico" v-model="form.incluyeOftanmolico">
                                    <label
                                        class="custom-control-label label-sm"
                                    for="incluyeOftanmolico">¿Oftalmológico?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.incluyeOftanmolico" class="text-danger">
                                    <small>
                                        {{ errorsFields.incluyeOftanmolico[0] }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-row bg-light">
                    <div class="col-md-6 mb-2 valign-wrapper">
                        <div class="form-row w-100">
                            <div class="col-md-12">
                                <div class="custom-control custom-checkbox">
                                    <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="tieneMedicoEmpresa"
                                    name="tieneMedicoEmpresa" v-model="form.tieneMedicoEmpresa">
                                    <label
                                        class="custom-control-label label-sm"
                                    for="tieneMedicoEmpresa">¿Tienen médico en la empresa?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.tieneMedicoEmpresa" class="text-danger">
                                    <small>
                                        {{ errorsFields.tieneMedicoEmpresa[0] }}
                                    </small>
                                </div>

                                <input class="form-control form-control-sm" type="text" id="nombreMedico" name="nombreMedico" v-model="form.nombreMedico" maxlength="50" placeholder="¿Con quién?" v-if="form.tieneMedicoEmpresa">
                                <div v-if="errorsFields && errorsFields.nombreMedico" class="text-danger">
                                    <small>
                                        {{ errorsFields.nombreMedico[0] }}
                                    </small>
                                </div>
                            </div>
                        </div>    
                    </div>

                    <div class="col-md-6 mb-2 valign-wrapper">
                        <div class="form-row w-100">
                            <div class="col-md-12">
                                <div class="custom-control custom-checkbox">
                                    <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="tieneFeriaSalud"
                                    name="tieneFeriaSalud" v-model="form.tieneFeriaSalud">
                                    <label
                                        class="custom-control-label label-sm"
                                    for="tieneFeriaSalud">¿Tienen feria de salud?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.tieneFeriaSalud" class="text-danger">
                                    <small>
                                        {{ errorsFields.tieneFeriaSalud[0] }}
                                    </small>
                                </div>

                                <input class="form-control form-control-sm" type="text" id="frecuenciaFeria" name="frecuenciaFeria" v-model="form.frecuenciaFeria" maxlength="25" placeholder="¿Con qué frecuencia?" v-if="form.tieneFeriaSalud">
                                <div v-if="errorsFields && errorsFields.frecuenciaFeria" class="text-danger">
                                    <small>
                                        {{ errorsFields.frecuenciaFeria[0] }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 mb-2" v-if="form.tieneFeriaSalud">
                        <label for="comentariosFeria" class="label-sm">Comentarios feria</label>
                        <textarea class="form-control form-control-sm" type="text" id="comentariosFeria" name="comentariosFeria" v-model="form.comentariosFeria" maxlength="255" rows="1"></textarea>
                        <div v-if="errorsFields && errorsFields.comentariosFeria" class="text-danger">
                            <small>
                                {{ errorsFields.comentariosFeria[0] }}
                            </small>
                        </div>
                    </div>  
                </div>
            </div>

            <div class="col-md-8">
                <div class="form-row">
                    <div class="col-md-6 mb-2">
                        <div class="card border">
                            <div class="card-body form-row p-1">
                                <div class="col-md-12 mb-1 border-bottom">
                                    <div class="form-row">
                                        <label class="col-md-5 valign-wrapper label-80">
                                            ¿Les interesan paquetes de: chequeos médicos?
                                        </label>
                                        <div class="col-md-7">
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesChequeoMedico1" name="interesChequeoMedico" v-model="form.interesChequeoMedico" class="custom-control-input" value="SI">
                                                <label class="custom-control-label label-70" for="interesChequeoMedico1">Sí</label>
                                            </div>
                                        
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesChequeoMedico2" name="interesChequeoMedico" v-model="form.interesChequeoMedico" class="custom-control-input" value="NO">
                                                <label class="custom-control-label label-70" for="interesChequeoMedico2">No</label>
                                            </div>

                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesChequeoMedico3" name="interesChequeoMedico" v-model="form.interesChequeoMedico" class="custom-control-input" value="NI">
                                                <label class="custom-control-label label-70" for="interesChequeoMedico3">No indíca</label>
                                            </div>
                                        </div>
                                        <div v-if="errorsFields && errorsFields.interesChequeoMedico" class="text-danger">
                                            <small>
                                                {{ errorsFields.interesChequeoMedico[0] }}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-1 border-bottom">
                                    <div class="form-row">
                                        <label class="col-md-5 valign-wrapper label-80">
                                            ¿Interés chequeo oftalmológico?
                                        </label>

                                        <div class="col-md-7">
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesChequeoOftanmologico1" name="interesChequeoOftanmologico" v-model="form.interesChequeoOftanmologico" class="custom-control-input" value="SI">
                                                <label class="custom-control-label label-70" for="interesChequeoOftanmologico1">Sí</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesChequeoOftanmologico2" name="interesChequeoOftanmologico" v-model="form.interesChequeoOftanmologico" class="custom-control-input" value="NO">
                                                <label class="custom-control-label label-70" for="interesChequeoOftanmologico2">No</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesChequeoOftanmologico3" name="interesChequeoOftanmologico" v-model="form.interesChequeoOftanmologico" class="custom-control-input" value="NI">
                                                <label class="custom-control-label label-70" for="interesChequeoOftanmologico3">No indíca</label>
                                            </div>  
                                        </div>
                                        <div v-if="errorsFields && errorsFields.interesChequeoOftanmologico" class="text-danger">
                                            <small>
                                                {{ errorsFields.interesChequeoOftanmologico[0] }}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-1 border-bottom" v-if="false">
                                    <div class="form-row">
                                        <label class="col-md-5 valign-wrapper label-80">
                                            ¿Interés chequeo optometrico?
                                        </label>
                                        
                                        <div class="col-md-7">
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesChequeoOptometrico1" name="interesChequeoOptometrico" v-model="form.interesChequeoOptometrico" class="custom-control-input" value="SI">
                                                <label class="custom-control-label label-70" for="interesChequeoOptometrico1">Sí</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesChequeoOptometrico2" name="interesChequeoOptometrico" v-model="form.interesChequeoOptometrico" class="custom-control-input" value="NO">
                                                <label class="custom-control-label label-70" for="interesChequeoOptometrico2">No</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesChequeoOptometrico3" name="interesChequeoOptometrico" v-model="form.interesChequeoOptometrico" class="custom-control-input" value="NI">
                                                <label class="custom-control-label label-70" for="interesChequeoOptometrico3">No indíca</label>
                                            </div>
                                        </div>
                                        <div v-if="errorsFields && errorsFields.interesChequeoOptometrico" class="text-danger">
                                            <small>
                                                {{ errorsFields.interesChequeoOptometrico[0] }}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-1 border-bottom">
                                    <div class="form-row">
                                        <label class="col-md-5 valign-wrapper label-80">
                                            ¿Interés móvil dental?
                                        </label>
                                        <div class="col-md-7">
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesMovilDental1" name="interesMovilDental" v-model="form.interesMovilDental" class="custom-control-input" value="SI">
                                                <label class="custom-control-label label-70" for="interesMovilDental1">Sí</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesMovilDental2" name="interesMovilDental" v-model="form.interesMovilDental" class="custom-control-input" value="NO">
                                                <label class="custom-control-label label-70" for="interesMovilDental2">No</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesMovilDental3" name="interesMovilDental" v-model="form.interesMovilDental" class="custom-control-input" value="NI">
                                                <label class="custom-control-label label-70" for="interesMovilDental3">No indíca</label>
                                            </div>  
                                        </div>
                                        <div v-if="errorsFields && errorsFields.interesMovilDental" class="text-danger">
                                            <small>
                                                {{ errorsFields.interesMovilDental[0] }}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-1 border-bottom">
                                    <div class="form-row">
                                        <label class="col-md-5 valign-wrapper label-80">
                                            ¿Interés evaluación postural?
                                        </label>
                                        <div class="col-md-7">
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesEvaluacionPostural1" name="interesEvaluacionPostural" v-model="form.interesEvaluacionPostural" class="custom-control-input" value="SI">
                                                <label class="custom-control-label label-70" for="interesEvaluacionPostural1">Sí</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesEvaluacionPostural2" name="interesEvaluacionPostural" v-model="form.interesEvaluacionPostural" class="custom-control-input" value="NO">
                                                <label class="custom-control-label label-70" for="interesEvaluacionPostural2">No</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesEvaluacionPostural3" name="interesEvaluacionPostural" v-model="form.interesEvaluacionPostural" class="custom-control-input" value="NI">
                                                <label class="custom-control-label label-70" for="interesEvaluacionPostural3">No indíca</label>
                                            </div>  
                                        </div>
                                        <div v-if="errorsFields && errorsFields.interesEvaluacionPostural" class="text-danger">
                                            <small>
                                                {{ errorsFields.interesEvaluacionPostural[0] }}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-1 border-bottom">
                                    <div class="form-row">
                                        <label class="col-md-5 valign-wrapper label-80">
                                            ¿Interés evaluación marcha?
                                        </label>
                                        <div class="col-md-7">
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesEvaluacionMarcha1" name="interesEvaluacionMarcha" v-model="form.interesEvaluacionMarcha" class="custom-control-input" value="SI">
                                                <label class="custom-control-label label-70" for="interesEvaluacionMarcha1">Sí</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesEvaluacionMarcha2" name="interesEvaluacionMarcha" v-model="form.interesEvaluacionMarcha" class="custom-control-input" value="NO">
                                                <label class="custom-control-label label-70" for="interesEvaluacionMarcha2">No</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="interesEvaluacionMarcha3" name="interesEvaluacionMarcha" v-model="form.interesEvaluacionMarcha" class="custom-control-input" value="NI">
                                                <label class="custom-control-label label-70" for="interesEvaluacionMarcha3">No indíca</label>
                                            </div>  
                                        </div>
                                        <div v-if="errorsFields && errorsFields.interesEvaluacionMarcha" class="text-danger">
                                            <small>
                                                {{ errorsFields.interesEvaluacionMarcha[0] }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-6 mb-2">
                        <div class="form-row">
                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="pruebasPreempleo"
                                    name="pruebasPreempleo" v-model="form.pruebasPreempleo">
                                    <label
                                        class="custom-control-label label-sm"
                                    for="pruebasPreempleo">¿Realizan exámenes pre-empleo?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.pruebasPreempleo" class="text-danger">
                                    <small>
                                        {{ errorsFields.pruebasPreempleo[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="pruebasAgudezaVisual"
                                    name="pruebasAgudezaVisual" v-model="form.pruebasAgudezaVisual">
                                    <label
                                        class="custom-control-label label-sm"
                                    for="pruebasAgudezaVisual">De agudeza visual?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.pruebasAgudezaVisual" class="text-danger">
                                    <small>
                                        {{ errorsFields.pruebasAgudezaVisual[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="pruebasDoping"
                                    name="pruebasDoping" v-model="form.pruebasDoping">
                                    <label
                                        class="custom-control-label label-sm"
                                    for="pruebasDoping">¿Pruebas de doping?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.pruebasDoping" class="text-danger">
                                    <small>
                                        {{ errorsFields.pruebasDoping[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="tieneProgramaWellness" 
                                        name="tieneProgramaWellness" v-model="form.tieneProgramaWellness">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="tieneProgramaWellness">¿Tiene programa Wellness?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.tieneProgramaWellness" class="text-danger">
                                    <small>
                                        {{ errorsFields.tieneProgramaWellness[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="interesPropuestaWellness" 
                                        name="interesPropuestaWellness" v-model="form.interesPropuestaWellness">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="interesPropuestaWellness">¿Interés propuesta Wellness?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.interesPropuestaWellness" class="text-danger">
                                    <small>
                                        {{ errorsFields.interesPropuestaWellness[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2" v-if="false">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="interesPlanFisioterapia" 
                                        name="interesPlanFisioterapia" v-model="form.interesPlanFisioterapia">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="interesPlanFisioterapia">¿Interés plan fisioterapia?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.interesPlanFisioterapia" class="text-danger">
                                    <small>
                                        {{ errorsFields.interesPlanFisioterapia[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="interesPlanFisioterapiaEnEmpresa" 
                                        name="interesPlanFisioterapiaEnEmpresa" v-model="form.interesPlanFisioterapiaEnEmpresa">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="interesPlanFisioterapiaEnEmpresa">¿Interés plan fisioterapia en empresa?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.interesPlanFisioterapiaEnEmpresa" class="text-danger">
                                    <small>
                                        {{ errorsFields.interesPlanFisioterapiaEnEmpresa[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2" v-if="false">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="conoceMasajeSilla" 
                                        name="conoceMasajeSilla" v-model="form.conoceMasajeSilla">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="conoceMasajeSilla">¿Conoce masaje silla?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.conoceMasajeSilla" class="text-danger">
                                    <small>
                                        {{ errorsFields.conoceMasajeSilla[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="interesMasajeSilla" 
                                        name="interesMasajeSilla" v-model="form.interesMasajeSilla">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="interesMasajeSilla">¿Interés masaje silla?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.interesMasajeSilla" class="text-danger">
                                    <small>
                                        {{ errorsFields.interesMasajeSilla[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2" v-if="false">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="conoceGimnasiaLaboral" 
                                        name="conoceGimnasiaLaboral" v-model="form.conoceGimnasiaLaboral">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="conoceGimnasiaLaboral">¿Conoce gimnasia laboral?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.conoceGimnasiaLaboral" class="text-danger">
                                    <small>
                                        {{ errorsFields.conoceGimnasiaLaboral[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="interesGimnasiaLaboral" 
                                        name="interesGimnasiaLaboral" v-model="form.interesGimnasiaLaboral">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="interesGimnasiaLaboral">¿Interés gimnasia laboral?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.interesGimnasiaLaboral" class="text-danger">
                                    <small>
                                        {{ errorsFields.interesGimnasiaLaboral[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="tieneAtencionMedicaDomicilio" 
                                        name="tieneAtencionMedicaDomicilio" v-model="form.tieneAtencionMedicaDomicilio">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="tieneAtencionMedicaDomicilio">¿Tiene atención médica domicilio?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.tieneAtencionMedicaDomicilio" class="text-danger">
                                    <small>
                                        {{ errorsFields.tieneAtencionMedicaDomicilio[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="tieneAsociacionSolidarista" 
                                        name="tieneAsociacionSolidarista" v-model="form.tieneAsociacionSolidarista">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="tieneAsociacionSolidarista">¿Tiene asociación solidarista?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.tieneAsociacionSolidarista" class="text-danger">
                                    <small>
                                        {{ errorsFields.tieneAsociacionSolidarista[0] }}
                                    </small>
                                </div>

                                <input type="text" class="form-control form-control-sm" name="contactoAsociacionSolidarista" v-model="form.contactoAsociacionSolidarista" placeholder="Contacto" maxlength="100" v-if="form.tieneAsociacionSolidarista">
                                <div v-if="errorsFields && errorsFields.contactoAsociacionSolidarista" class="text-danger">
                                    <small>
                                        {{ errorsFields.contactoAsociacionSolidarista[0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6 mb-2">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                        type="checkbox" 
                                        class="custom-control-input" 
                                        id="tieneSaludOcupacional" 
                                        name="tieneSaludOcupacional" v-model="form.tieneSaludOcupacional">
                                    <label 
                                        class="custom-control-label label-sm" 
                                        for="tieneSaludOcupacional">¿Tiene salud ocupacional?</label>
                                </div>
                                <div v-if="errorsFields && errorsFields.tieneSaludOcupacional" class="text-danger">
                                    <small>
                                        {{ errorsFields.tieneSaludOcupacional[0] }}
                                    </small>
                                </div>
                                <input type="text" class="form-control form-control-sm" name="contactoSaludOcupacional" v-model="form.contactoSaludOcupacional" placeholder="Contacto" maxlength="100" v-if="form.tieneSaludOcupacional">
                                <div v-if="errorsFields && errorsFields.contactoSaludOcupacional" class="text-danger">
                                    <small>
                                        {{ errorsFields.contactoSaludOcupacional[0] }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
	export default {
        props: ['errors', 'values', 'data'],

		data(){
			return {
				form: {
					numeroSites: '',
					tieneTeletrabajo: '',
					tieneSeguroMedico: '',
					aseguradora: '',
					tieneCorredorSeguros: '',
					intermediario: '',
					polizaAplicaGerentes: '',
					polizaAplicaMandosMedios: '',
					polizaAplicaEmpresa: '',
					polizaNoAplica: '',
					tieneSeguroVida: '',
					aseguradoraVida: '',
					incluyeChequeoMedio: '',
					incluyeOftanmolico: '',
					tieneMedicoEmpresa: '',
					nombreMedico: '',
					tieneFeriaSalud: '',
					frecuenciaFeria: '',
					comentariosFeria: '',
					interesChequeoMedico: '',
					interesChequeoOftanmologico: '',
					interesChequeoOptometrico: '',
					interesMovilDental: '',
					interesEvaluacionPostural: '',
					interesEvaluacionMarcha: '',
					pruebasPreempleo: '',
					pruebasAgudezaVisual: '',
					pruebasDoping: '',
					tieneProgramaWellness: '',
					interesPropuestaWellness: '',
					interesPlanFisioterapia: '',
					interesPlanFisioterapiaEnEmpresa: '',
					conoceMasajeSilla: '',
					interesMasajeSilla: '',
					conoceGimnasiaLaboral: '',
					interesGimnasiaLaboral: '',
					tieneAtencionMedicaDomicilio: '',
					tieneAsociacionSolidarista: '',
					contactoAsociacionSolidarista: '',
					tieneSaludOcupacional: '',
					contactoSaludOcupacional: '',

                    giroNegocio: '',
                    renovacionPoliza: '',
                    numeroEmpleados: '',

				}
			}
		},

        created: function(){
            if (this.valuesData.length>0) {
                this.getData(this.valuesData)
            }else{
                this.getFormulario(this.valuesFormulario)
            }
        },

        methods: {
            getData: function(val){
                this.form.numeroSites = val.numeroSites
                this.form.tieneTeletrabajo = val.tieneTeletrabajo
                this.form.tieneSeguroMedico = val.tieneSeguroMedico
                this.form.aseguradora = val.aseguradora
                this.form.tieneCorredorSeguros = val.tieneCorredorSeguros
                this.form.intermediario = val.intermediario
                this.form.polizaAplicaGerentes = val.polizaAplicaGerentes
                this.form.polizaAplicaMandosMedios = val.polizaAplicaMandosMedios
                this.form.polizaAplicaEmpresa = val.polizaAplicaEmpresa
                this.form.polizaNoAplica = val.polizaNoAplica
                this.form.tieneSeguroVida = val.tieneSeguroVida
                this.form.aseguradoraVida = val.aseguradoraVida
                this.form.incluyeChequeoMedio = val.incluyeChequeoMedio
                this.form.incluyeOftanmolico = val.incluyeOftanmolico
                this.form.tieneMedicoEmpresa = val.tieneMedicoEmpresa
                this.form.nombreMedico = val.nombreMedico
                this.form.tieneFeriaSalud = val.tieneFeriaSalud
                this.form.frecuenciaFeria = val.frecuenciaFeria
                this.form.comentariosFeria = val.comentariosFeria
                this.form.pruebasPreempleo = val.pruebasPreempleo
                this.form.pruebasAgudezaVisual = val.pruebasAgudezaVisual
                this.form.pruebasDoping = val.pruebasDoping
                this.form.interesChequeoMedico = val.interesChequeoMedico
                this.form.interesChequeoOftanmologico = val.interesChequeoOftanmologico
                this.form.interesChequeoOptometrico = val.interesChequeoOptometrico
                this.form.interesMovilDental = val.interesMovilDental
                this.form.interesEvaluacionPostural = val.interesEvaluacionPostural
                this.form.interesEvaluacionMarcha = val.interesEvaluacionMarcha
                this.form.tieneProgramaWellness = val.tieneProgramaWellness
                this.form.interesPropuestaWellness = val.interesPropuestaWellness
                this.form.interesPlanFisioterapia = val.interesPlanFisioterapia
                this.form.interesPlanFisioterapiaEnEmpresa = val.interesPlanFisioterapiaEnEmpresa
                this.form.conoceMasajeSilla = val.conoceMasajeSilla
                this.form.interesMasajeSilla = val.interesMasajeSilla
                this.form.conoceGimnasiaLaboral = val.conoceGimnasiaLaboral
                this.form.interesGimnasiaLaboral = val.interesGimnasiaLaboral
                this.form.tieneAsociacionSolidarista = val.tieneAsociacionSolidarista
                this.form.contactoAsociacionSolidarista = val.contactoAsociacionSolidarista
                this.form.tieneSaludOcupacional = val.tieneSaludOcupacional
                this.form.contactoSaludOcupacional = val.contactoSaludOcupacional
                this.form.tieneAtencionMedicaDomicilio = val.tieneAtencionMedicaDomicilio
                this.form.giroNegocio = val.giroNegocio
                this.form.renovacionPoliza = val.renovacionPoliza
                this.form.numeroEmpleados = val.numeroEmpleados
            },

            getFormulario: function(val){
                this.form.numeroSites = val.NUMERO_SITES
                this.form.tieneTeletrabajo = (val.TIENE_TELETRABAJO == "SI") ? true : false
                this.form.tieneSeguroMedico = (val.TIENE_SEGURO_MEDICO == "SI") ? true : false
                this.form.aseguradora = val.CODIGO_ASEGURADORA
                this.form.tieneCorredorSeguros = (val.TIENE_CORREDOR_SEGUROS == "SI") ? true : false
                this.form.intermediario = val.CODIGO_INTERMEDIARIO
                this.form.polizaAplicaGerentes = (val.POLIZA_APLICA_GERENTES == "SI") ? true : false
                this.form.polizaAplicaMandosMedios = (val.POLIZA_APLICA_MANDOS_MEDIOS == "SI") ? true : false
                this.form.polizaAplicaEmpresa = (val.POLIZA_APLICA_EMPRESA == "SI") ? true : false
                this.form.polizaNoAplica = (val.POLIZA_NO_APLICA == "SI") ? true : false
                this.form.tieneSeguroVida = (val.TIENE_SEGURO_VIDA == "SI") ? true : false
                this.form.aseguradoraVida = val.CODIGO_ASEGURADORA_VIDA
                this.form.incluyeChequeoMedio = (val.INCLUYE_CHEQUEO_MEDIO == "SI") ? true : false
                this.form.incluyeOftanmolico = (val.INCLUYE_OFTANMOLICO == "SI") ? true : false
                this.form.tieneMedicoEmpresa = (val.TIENE_MEDICO_EMPRESA == "SI") ? true : false
                this.form.nombreMedico = val.NOMBRE_MEDICO
                this.form.tieneFeriaSalud = (val.TIENE_FERIA_SALUD == "SI") ? true : false

                this.form.frecuenciaFeria = val.FRECUENCIA_FERIA
                this.form.comentariosFeria = val.COMENTARIOS_FERIA
                this.form.pruebasPreempleo = (val.PRUEBAS_PREEMPLEO == "SI") ? true : false
                this.form.pruebasAgudezaVisual = (val.PRUEBAS_AGUDEZA_VISUAL == "SI") ? true : false
                this.form.pruebasDoping = (val.PRUEBAS_DOPING == "SI") ? true : false

                this.form.interesChequeoMedico = val.INTERES_CHEQUEO_MEDICO
                this.form.interesChequeoOftanmologico = val.INTERES_CHEQUEO_OFTANMOLOGICO
                this.form.interesChequeoOptometrico = val.INTERES_CHEQUEO_OPTOMETRICO
                this.form.interesMovilDental = val.INTERES_MOVIL_DENTAL
                this.form.interesEvaluacionPostural = val.INTERES_EVALUACION_POSTURAL
                this.form.interesEvaluacionMarcha = val.INTERES_EVALUACION_MARCHA
                this.form.tieneProgramaWellness = (val.TIENE_PROGRAMA_WELLNESS == "SI") ? true : false
                this.form.interesPropuestaWellness = (val.INTERES_PROPUESTA_WELLNESS == "SI") ? true : false
                this.form.interesPlanFisioterapia = (val.INTERES_PLAN_FISIOTERAPIA == "SI") ? true : false
                this.form.interesPlanFisioterapiaEnEmpresa = (val.INTERES_PLAN_FISIOTERAPIA_EN_EMPRESA == "SI") ? true : false
                this.form.conoceMasajeSilla = (val.CONOCE_MASAJE_SILLA == "SI") ? true : false
                this.form.interesMasajeSilla = (val.INTERES_MASAJE_SILLA == "SI") ? true : false
                this.form.conoceGimnasiaLaboral = (val.CONOCE_GIMNASIA_LABORAL == "SI") ? true : false
                this.form.interesGimnasiaLaboral = (val.INTERES_GIMNASIA_LABORAL == "SI") ? true : false
                this.form.tieneAsociacionSolidarista = (val.TIENE_ASOCIACION_SOLIDARISTA == "SI") ? true : false
                this.form.contactoAsociacionSolidarista = val.CONTACTO_ASOCIACION_SOLIDARISTA
                this.form.tieneSaludOcupacional = (val.TIENE_SALUD_OCUPACIONAL == "SI") ? true : false
                this.form.contactoSaludOcupacional = val.CONTACTO_SALUD_OCUPACIONAL
                this.form.tieneAtencionMedicaDomicilio = (val.TIENE_ATENCION_MEDICA_DOMICILIO == "SI") ? true : false

                this.form.giroNegocio = val.CODIGO_SEGMENTO
                this.form.renovacionPoliza = val.FECHA_RENOVACION ? moment(val.FECHA_RENOVACION).format('DD-MM-YYYY') : '';
                this.form.numeroEmpleados = val.NUMERO_EMPLEADOS
            }
        },

        computed: {
            errorsFields: function(){
                return JSON.parse(this.errors);
            },

            valuesData: function(){
                return JSON.parse(this.values)
            },

            valuesFormulario: function(){
                return JSON.parse(this.data)
            }
        },

		watch: {
			'form.tieneSeguroMedico': function(val){
				if (val == true) {
					this.form.aseguradora = ''
				}
			},

			'form.tieneCorredorSeguros': function(val){
				if (val == true) {
					this.form.intermediario = ''
				}
			},

			'form.tieneSeguroVida': function(val){
				if (val == true) {
					this.form.aseguradoraVida = ''
				}
			},

			'form.tieneMedicoEmpresa': function(val){
				if (val == true) {
					this.form.nombreMedico = ''
				}
			},

			'form.tieneFeriaSalud': function(val, oldValue){
				if (val == true) {
                    this.form.frecuenciaFeria = ''
					this.form.comentariosFeria = ''
				}
			},

			'form.tieneAsociacionSolidarista': function(val){
				if (val == true) {
					this.form.contactoAsociacionSolidarista = ''
				}
			},

			'form.tieneSaludOcupacional': function(val){
				if (val == true) {
					this.form.contactoSaludOcupacional = ''
				}
		    },

            /*valuesData: {
                handler: function(val){
                    this.getData(val)
                },
                deep:true
            },

            valuesFormulario: {
                handler: function(val){
                    this.getFormulario(val)
                },
                deep:true
            }*/
		}
	}
</script>